import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment.development';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WalletServiceService {
  // @Output("login") ClickInLogin: EventEmitter<any> = new EventEmitter<void>();
  @Output('getCartList') cartClick: EventEmitter<any> =
    new EventEmitter<void>();
  @Output('chackOut') cartClickInCheckOut: EventEmitter<any> =
    new EventEmitter<void>();
  @Output('getWishlist') wishlistClick: EventEmitter<any> =
    new EventEmitter<void>();

  constructor(private http: HttpClient) {}


  private balanceSubject = new BehaviorSubject<number>(0);

  balance$ = this.balanceSubject.asObservable();

  setBalance(balance: number) {
    this.balanceSubject.next(Number(balance) || 0);
  }

  getBalance(): number {
    return this.balanceSubject.value;
  }




   updateBalance(balance: number) {
    this.balanceSubject.next(Number(balance) || 0);
  }
          
  
 getAllWallet(): Observable<any> {
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.getAllWalletList
    }`;
    return this.http.get(url);
  }



getRewardHistory(userId: string): Observable<any> {
  return this.http.get(`${environment.apiBaseUrl}getRewardHistory/${userId}`);
}
  
getRewardWallet(userId: string): Observable<any> {
  return this.http.get(`${environment.apiBaseUrl}getRewardWallet/${userId}`);
}
   getAllCoupons(): Observable<any> {
   
  return this.http.get(`${environment.apiBaseUrl}getAllCoupons`);
  };

 filterRewardHistory1(type: string = 'All') {

  let url = `${environment.apiBaseUrl}filterRewardHistory`;

  if (type !== 'All') {
    url += `?type=${type}`;
  }

  return this.http.get(url);

}
  filterRewardHistory(type: string, fromDate?: string, toDate?: string) {

  let params: any = {};

  if (type !== 'All') {
    params.type = type;
  }

  if (fromDate) {
    params.fromDate = fromDate;
  }

  if (toDate) {
    params.toDate = toDate;
  }

  return this.http.get(
    `${environment.apiBaseUrl}filterRewardHistory`,
    { params }
  );

}

  getRecentlyViewedProducts(userId: string): Observable<any> {
    const token = localStorage.getItem('token'); // or wherever you store the token
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const url = `${environment.apiBaseUrl}user/${userId}/recently-viewed-products`;
    return this.http.get<any>(url, { headers });
  }

  // Method to fetch similar products
  getSimilarProducts(productId: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    // Correct URL structure
    return this.http.get<any>(
      `${environment.apiBaseUrl}/product/${productId}/similar`,
      { headers }
    );
  }

  searchProducts(
    searchTerm: string,
    page: number = 1,
    limit: number = 12
  ): Observable<any> {
    const params = new HttpParams()
      .set('search', searchTerm)
      .set('page', page.toString())
      .set('limit', limit.toString());

    return this.http.get(
      `${environment.apiBaseUrl + environment.apiEndPoint.prodcutSearch}`,
      { params }
    );
  }

  // Fetch all order transactions
  allOrderTransaction(): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('token')}`, // Assumes token is stored in localStorage
    });

    return this.http.get(
      `${environment.apiBaseUrl + environment.apiEndPoint.allOrderTransaction}`,
      { headers }
    );
  }

  // Fetch all user reviews o product
  userReviews(): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('token')}`, // Assumes token is stored in localStorage
    });

    return this.http.get(
      `${environment.apiBaseUrl + environment.apiEndPoint.userReviews}`,
      { headers }
    );
  }

  // Fetch discounted products
  getDiscountedProducts(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/product-discount`);
  }
  // Fetch discounted products
  getDiscountedOnFashionProducts(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/product-discount-on-fashion`);
  }


  
 
  

  popularProdut(): Observable<any> {
    return this.http.get(
      `${environment.apiBaseUrl}/popular-products`
    );
  }


  

    getDiscountedOnFurnitureProducts(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/product-discount-on-furniture`);
  }

 

  // createCashFreeOrder(payload: any) {
  //   return this.http.post(
  //     `${environment.apiBaseUrl}payment/create-order`,
  //     payload
  //   );
  // }

  


 
  getSellerReviews(sellerId: any): Observable<any> {
    const url = `${
      environment.apiBaseUrl + environment.apiEndPoint.sellerStoreDetails
    }/${sellerId}/reviews`;
    return this.http.get(url);
  }



  
  


 


}
